export const initialTracks = [
  {
    url: `${process.env.PUBLIC_URL}/xfiles.mp3`,
    duration: 52,
    metaData: {
      title: 'The X-Files (Full Theme)',
      artist: 'Mark Snow',
      album: 'The X-Files OST',
    },
  },
  {
    url: 'https://archive.org/download/hey-ya_202402/Hey%20Ya.mp3',
    duration: 237,
    metaData: {
      title: 'Hey Ya!',
      artist: 'OutKast',
      album: 'Speakerboxxx/The Love Below (2003)',
    },
  },
  {
    url: 'https://archive.org/download/50-cent-in-da-club-official-music-video_20250225/50%20Cent%20-%20In%20Da%20Club%20(Official%20Music%20Video).mp3',
    duration: 248,
    metaData: {
      title: 'In Da Club',
      artist: '50 Cent',
      album: 'Get Rich or Die Tryin\' (2003)',
    },
  },
  {
    url: "https://archive.org/download/shakira-hips-dont-lie-ft.-wyclef-jean/Shakira%20-%20Hips%20Don't%20Lie%20ft.%20Wyclef%20Jean.mp3",
    duration: 218,
    metaData: {
      title: "Hips Don't Lie",
      artist: 'Shakira ft. Wyclef Jean',
      album: 'Oral Fixation Vol. 2 (2006)',
    },
  },
  {
    url: 'https://archive.org/download/chaiyya-chaiyya-dil-se/Chaiyya%20Chaiyya%20-%20Dil%20Se.mp3',
    duration: 414,
    metaData: {
      title: 'Chaiyya Chaiyya',
      artist: 'Sukhwinder Singh & Sapna Awasthi',
      album: 'Dil Se (1998)',
    },
  },
];
